"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pickReactKnownProp = require("pick-react-known-prop");

function ImageComponent(_ref) {
  var alt = _ref.alt,
      size = _ref.size,
      src = _ref.src,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["alt", "size", "src"]);

  var _ref2 = typeof src === 'string' ? [null, src] : src.find(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
        st = _ref5[0];

    return st === size;
  }) || [],
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      imgSrc = _ref3[1];

  return /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    src: imgSrc,
    alt: alt
  }));
}

process.env.NODE_ENV !== "production" ? ImageComponent.propTypes = {
  alt: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']), _propTypes.default.string]).isRequired,
  src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]).isRequired
} : void 0;
ImageComponent.defaultProps = {
  alt: undefined
};
var _default = ImageComponent;
exports.default = _default;